import { WorkRoleScoreRange } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { ListEntry, ListFieldInfo } from '../../../common/list/list-types';

type WorkRoleScoreRangeListEntry = ListEntry<WorkRoleScoreRange>;

export const WorkRoleScoreRangeListView: ListFieldInfo<WorkRoleScoreRangeListEntry, undefined>[] = [
  {
    name: 'label',
    label: 'Label',
    kind: 'mapped',
    map: entry => entry.scoreRange.label.value.en,
    displayed: true,
    sortable: false
  },
  {
    name: 'rangeMin',
    label: 'Minimum',
    kind: 'mapped',
    map: entry => `${entry.scoreRange.range.v1}`,
    displayed: true,
    sortable: false
  },
  {
    name: 'rangeMax',
    label: 'Maximum',
    kind: 'mapped',
    map: entry => `${entry.scoreRange.range.v2}`,
    displayed: true,
    sortable: false
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/workrole-list/workrole-score-range-list-view.ts